import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";

export function ClassifiedSummary() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    );
}

